<template>
  <div class="clauserowdiv">
    <div class="div-block">
      <div class="text-block-3">
        <a
          :href="
            `http://clause.scwp.com/#/dashboard/clauses/clause/view/${clause.newestVersion}`
          "
          target="_blank"
          class="url"
          >{{ clause.name }}</a
        >
      </div>
      <div :class="stateClasses">{{ state }}</div>
    </div>
    <div class="div-block-2">
      <a @click="$emit('sharePressed', clause)" href="#" class="link-block w-inline-block">
        <img src="static/images/back-arrow.png" alt="" class="image-2" />
      </a>
      <a v-if="clause.refresh" @click="showInfo()" href="#" class="link-block w-inline-block">
        <img src="static/images/info.png" alt="" class="image-2" />
      </a>
    </div>
  </div>
</template>

<script>
import clausemixin from './mixins/clause.mixin'
export default {
  mixins: [clausemixin],
  computed: {
    state () {
      if (this.clause.refresh) {
        return 'ABWEICHEND'
      }
      return 'AKTUELL'
    },
    stateClasses () {
      return {
        clausestatus: true,
        expired: this.clause.refresh
      }
    }
  },
  methods: {
    showInfo () {
      this.$emit('showInfo', this.clause)
    }
  }
}
</script>

<style>
.url {
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ScanClause.vue